import styled from "styled-components";

export const breakpoints = {
  xs: '480px',
  sm: '600px',
  md: '960px',
  lg: '1127px',
};

export const LayoutStyled = styled.div`
  font-family: 'Nunito Sans';
  max-width: 740px;
  margin: 0 auto;
  padding: 24px;

  .items-content p {
    text-align: center;
    margin-bottom: 34px;
    margin-top: 0px;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    padding: 24px 12px;
  }
`;

export const QRIconStyled = styled.div`
  width: 33px;
  height: 33px;
  margin: 0 auto;
`;

export const QrInfoStyled = styled.div`
  display: flex;
  margin-bottom: 32px;
  .column {
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 24px;
    &.left {
      width: 172px;
      flex: 0 0 172px;
      margin-right: 12px;
      padding: 10px;
    }

    &.right {
      flex: 1;
      text-align: center;

      p {
        max-width: 331px;
      }
    }
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    background-color: white;
    .column {
      &.left {
        width: 100%;
        margin-right: 0;
        padding: 10px 16px;
        > div > div {
          padding-left: 0;
        }
      }
      &.right {
        padding: 0 12px 0 0;
      }
    }
  }
`;

export const ScanLabel = styled.p<{ type: string;}>`
    
    display:${(props) => (props.type == 'mobile' ? 'none' : 'block')};
  @media screen and (max-width: ${breakpoints.sm} ) {
    display:${(props) => (props.type == 'mobile' ? 'block' : 'none')};
  }
  
`

export const QRButtonLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${breakpoints.sm} ) {
    display: none;
  }
`;

export const ButtonIconStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 45px;
    cursor: pointer;
    border: none;
    font-weight: normal;
    text-decoration: underline;
    svg {
      margin-right: 5px;
    }

    @media screen and (max-width: ${breakpoints.xs} ) {
      font-size: 13px;
      padding: 12px 2px;
    }
  }
`;

export const ViewRewardsOffersButtonStyled = styled.div`
  button {
    padding: 11px 24px;
    cursor: pointer;
  }
`;

export const ViewRewardsOffersStyled = styled.div`
  border: 1px dashed black;
  text-align: center;
  background-color: white;
  padding: 27px 44px;
  margin-bottom: 34px;
  p {
    font-size: 16px;
    margin-top: 0;
  }
`;

export const ViewOderOnlineButtonStyled= styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 30%;
  padding-right: 30%;
  margin-top: 18px;

  button {
    width: auto;
    padding: 12px 20px;
    cursor: pointer;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const RewardOffersContentStyled = styled.div`
  width: 356px;
  margin: 0 auto;

  a {
    text-align: center;
    margin-bottom: 30px;
    margin-top: 30px;
    display: block;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    width: 100%;
  }
`;

export const RewardOfferItemStyled = styled.div`
  margin-bottom: 12px;
`;

